type Data = {
  paymentMode: string;
  cashAmount: string;
};

export const Validation = (
  data: Data,
  setError: (a: any) => void,
  setCashError: (a: any) => void
) => {
  let isError = false;
  if (data.paymentMode === "") {
    setError((prevState: any) => ({
      ...prevState,
      paymentMode: "Please select the payment mode",
    }));
    isError = true;
  }
  if (isNaN(Number(data.cashAmount))) {
    setCashError("Enter amount in numbers only!");
    isError = true;
  }
  return isError;
};

export const amountValidation = (data: string, setError: (a: any) => void) => {
  let isError = false;
  if (data === "") {
    setError("Please enter cash amount!");
    isError = true;
  }
  if (isNaN(Number(data))) {
    setError("Enter amount in numbers only!");
    isError = true;
  }
  return isError;
};

export const chequeValidation = (data: string, setError: (a: any) => void) => {
  let isError = false;
  if (data === "") {
    setError("Please enter cheque number!");
    isError = true;
  }
  return isError;
};
